import { GameData, GameDataJSON } from "./GameData";
import { ScenarioConfiguration } from "./Scenario";


export interface GameDocument {
  id: string;
  player: string;
  session: string;
  scenarioID: string;
  data: GameDataJSON;
}

export class Game {

  #gameData = new GameData();

  constructor(
    public readonly id: string,
    public readonly player: string,
    public readonly session: string,
    public readonly scenarioID: string,
  ) {}

  private setData( data: GameDataJSON ) {
    this.#gameData = GameData.fromJSON(data);
    return this;
  }

  reset(scenarioConfig: ScenarioConfiguration) {
    this.#gameData = this.#gameData.reset(scenarioConfig);
    return this;
  }

  readEmail(emailID: string) {
    this.#gameData = this.#gameData.readEmail(emailID);
    return this;
  }

  setVariable(variableName: string, year: number, value: number) {
    this.#gameData = this.#gameData.setVariable(variableName, year, value);
    return this;
  }

  compute() {
    this.#gameData = this.#gameData.compute();
    return this;
  }

  submit() {
    this.#gameData = this.#gameData.submit();
    return this;
  }

  static fromDocument(document: GameDocument) {
    return new Game(
      document.id,
      document.player,
      document.session,
      document.scenarioID,
    )
      .setData(document.data);
  }

  toDocument(): GameDocument {
    return {
      id: this.id,
      player: this.player,
      session: this.session,
      scenarioID: this.scenarioID,
      data: this.#gameData.toJSON()
    }
  }
  
}